import UnsavedChangesAlert from "../../../ShareElements/UnsavedChangesAlert/UnsavedChangesAlert";
import Rotator from "../../../../../../Assets/Images/ButtonLoadingIcon.svg";
import EditActive from "../../../../../../Assets/Images/edit-deactive.svg";
import EditDeactive from "../../../../../../Assets/Images/edit-active.svg";
import ViewDeactive from "../../../../../../Assets/Images/eye (2).svg";
import ViewActive from "../../../../../../Assets/Images/eye (1).svg";
import BluePlus from "../../../../../../Assets/Images/plus-blue.svg";
import Delete from "../../../../../../Assets/Images/delete.svg";
import Alert from "../../../ShareElements/Alert/Alert";
import React, { useState, useEffect } from "react";
import { Config } from "../../../../../../Config";
import axios from "axios";
import ACLMappingRowItem from "../SharedElements/ACLMappingRowItem";
import ACLMappingAddedRowItem from "../SharedElements/ACLMappingAddedRowItem";

const Mapping = (props) => {
  const [CreatedProfileId] = useState(
    window.localStorage.getItem("CreatedProfileId")
  );
  const [DeleteAddedItemIsOpen, setDeleteAddedItemIsOpen] = useState(false);
  const [UnsavedChanges, setUnsavedChanges] = useState(false);
  const [DeleteIsOpen, setDeleteIsOpen] = useState(false);
  const [PageData, setPageData] = useState([]);
  const [Scopes, setScopes] = useState([]);
  const [ACLs, setACLs] = useState([]);
  const [ItemToDelete, setItemToDelete] = useState();
  const [PreviousModalId, setPrevModalId] = useState();
  const [DataIsLoaded, setDataIsLoaded] = useState(false);
  const [AddedItems, setAddedItems] = useState([]);
  const [AddedItemToDelete, setAddedItemToDelete] = useState();
  const [HasErrors, setHasErrors] = useState(false);
  const [ProfileName, setProfileName] = useState("");
  const [MappingCreated, setMappingCreated] = useState(false);
  const [IdAskedToDelete, setIdSelectedToDelete] = useState("");
  const [IdsToDelete] = useState([]); // to store the IDs of those items ther user confirms to delete.
  const [IsLoading, setIsLoading] = useState(false);

  // Initialization functions, called on component mount
  useEffect(() => {
    fetchAllACLs();
    if (window.localStorage.getItem("CreatedProfileNameString") !== null) {
      setProfileName(window.localStorage.getItem("CreatedProfileNameString"));
    }
    if (window.localStorage.getItem("MappingCreated") == 0) {
      setMappingCreated(false);
      fetchTemplate();
    } else if (window.localStorage.getItem("MappingCreated") == 1) {
      setMappingCreated(true);
      fetchTemplate();
      getProfileMappings();
    } else {
      setMappingCreated(false);
      fetchTemplate();
    }
  }, []);

  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0].label_value;
  };

  // in case the user saves their changes and moves to another tab, based on
  // a global variable named MappingCreated used in useEffect hook. This function is
  // called when the user creates mappings for the profile and switches tabs. Otherwise,
  // the fetchTemplate() function is called and a template is created on the page.
  const getProfileMappings = () => {
    let APIdata = {
      criteria: {
        roleId: window.localStorage.getItem("CreatedProfileId"),
      },
      size: 110,
      start: 0,
    };
    let Req = {
      method: "POST",
      baseURL: window._env_.API_URL + Config.ACLBaseURL + "/api/mapping/search",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "application/json",
      },
      data: APIdata,
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        createPrevRowsData(Res.data);
      })
      .catch((Err) => {
        console.log(Err);
      });
  };

  const createPrevRowsData = (ResData) => {
    console.log(ResData);
    let PageRows = [];
    ResData.results.map((Item, i) => {
      let ObjectToPush = {
        aclId: Item.acl.id,
        edit: Item.edit,
        view: Item.view,
        enabled: Item.enabled,
        scopeId: Item.scope.id,
        preselectedACLName: Item.acl.name,
        preselectedScopeName: Item.scope.name,
        id: Item.id,
      };
      PageRows.push(ObjectToPush);
    });
    setPageData(PageRows);
  };

  // This function fetches a predefined template for the page in case there are no previously
  // created acl mappings for the current Profile (roleId)
  const fetchTemplate = () => {
    let Req = {
      method: "GET",
      baseURL:
        window._env_.API_URL + Config.ACLBaseURL + "/api/mapping/template",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        setScopes(Res.data.scopes);
        if (
          window.localStorage.getItem("MappingCreated") == 0 ||
          window.localStorage.getItem("MappingCreated") == null
        ) {
          createRowsData(Res.data);
        }
      })
      .catch((Err) => {
        console.log(Err);
      });
  };
  const createRowsData = (ResData) => {
    let RowsData = ResData.mappings.splice(0, 9);
    let PageRows = [];
    RowsData.map((Item, i) => {
      let ObjectToPush = {
        aclId: Item.aclId,
        edit: Item.edit,
        view: Item.view,
        enabled: Item.enabled,
        scopeId: Item.scopeId,
      };
      var data = ResData.alcs;
      var filter = "id";
      var keyword = Item.aclId;
      var filteredData = data.filter((obj) => {
        return obj[filter] === keyword;
      });
      ObjectToPush.preselectedACLName = filteredData[0].name;

      var ScopesData = ResData.scopes;
      var ScopesFilter = "id";
      var Keyword = Item.scopeId;
      var filteredScope = ScopesData.filter(function (Obj) {
        return Obj[ScopesFilter] === Keyword;
      });
      ObjectToPush.preselectedScopeName = filteredScope[0].name;

      PageRows.push(ObjectToPush);
    });
    setPageData(PageRows);
  };
  const fetchAllACLs = () => {
    let ReqData = {
      size: 1000,
      start: 0,
    };
    let Req = {
      method: "POST",
      baseURL: window._env_.API_URL + Config.ACLBaseURL + "/api/acl/search",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "application/json",
      },
      data: JSON.stringify(ReqData),
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        setACLs(Res.data.results);
      })
      .catch((Err) => {
        console.log(Err);
      });
  };
  const closeAlert = () => {
    setUnsavedChanges(false);
  };
  const cancelDelete = () => {
    setDeleteIsOpen(false);
  };
  const enableSave = () => {
    document.getElementById("save-btn").classList.remove("disabled");
    window.localStorage.setItem("HasUnsaveChanges", 1); // 1 means true, 0 means false
  };
  const handleSwitchChange = () => {
    enableSave();
  };
  const handleCheckboxChange = (SelectedName, i) => {
    window.localStorage.setItem("HasUnsaveChanges", 1); // 1 means true, 0 means false
    enableSave();
    let ViewIsActive = document.getElementById(
      "View-" + i + "-icon-checkbox"
    ).checked;
    let EditIsActive = document.getElementById(
      "Edit-" + i + "-icon-checkbox"
    ).checked;
    if (SelectedName === "View-") {
      if (!ViewIsActive && EditIsActive) {
        document.getElementById("Edit-" + i + "-icon").src = EditDeactive;
        document.getElementById("Edit-" + i + "-icon-checkbox").checked = false;
      }
    } else {
      handleEdit(i);
    }
  };
  const handleEdit = (i) => {
    let EditIsChecked = document.getElementById(
      "Edit-" + i + "-icon-checkbox"
    ).checked;
    let ViewIsChecked = document.getElementById(
      "View-" + i + "-icon-checkbox"
    ).checked;
    if (!ViewIsChecked) {
      document.getElementById("View-" + i + "-icon").src = ViewActive;
      document.getElementById("View-" + i + "-icon-checkbox").checked = true;
    }
  };
  // Opens and closes the small modal displayed for each row in the table based on conditions
  const openModal = (i) => {
    setPrevModalId("modal-" + i);
    if (PreviousModalId !== undefined) {
      if (document.getElementById("modal-" + i).style.display === "block") {
        document.getElementById("modal-" + i).style.display = "none";
      } else if (
        document.getElementById("modal-" + i).style.display === "none" &&
        PreviousModalId === "modal-" + i
      ) {
        document.getElementById("modal-" + i).style.display = "block";
      } else {
        if (
          document.getElementById("modal-" + i) !== null &&
          document.getElementById("modal-" + PreviousModalId) !== null
        ) {
          document.getElementById("modal-" + i).style.display = "block";
          document.getElementById("modal-" + PreviousModalId).style.display =
            "none";
        }
      }
    } else {
      document.getElementById("modal-" + i).style.display = "block";
    }
    setPrevModalId(i);
  };
  const showDeleteAlert = (i, id) => {
    setIdSelectedToDelete(id);
    setItemToDelete(i);
    openModal(i);
    setDeleteIsOpen(true);
  };
  const acceptDelete = () => {
    setPrevModalId(undefined); // to reset the progress of opening context menu ( openModal() )
    IdsToDelete.push(IdAskedToDelete);
    enableSave();
    setDeleteIsOpen(false);
    PageData.splice(ItemToDelete, 1);
    setDataIsLoaded(!DataIsLoaded);
  };
  const disableSaveBtn = () => {
    document.getElementById("save-btn").classList.add("disabled");
    window.localStorage.setItem("HasUnsaveChanges", 0); // 1 means true, 0 means false
    setUnsavedChanges(false);
  };
  // handles the duplication of the existing rows
  const duplicateItem = (RowItem, i) => {
    enableSave();
    setPageData((data) => {
      let RowsData = [...data]; // itterating the current data
      // creating the duplicate item properties
      const aclId = `${document.getElementById("ACL-" + i + "-filter").value}`;
      const scopeId = `${
        document.getElementById("Scope-" + i + "-filter").value
      }`;
      const preselectedScopeName = document.getElementById(
        "Scope-" + i + "-filter"
      ).options[
        document.getElementById("Scope-" + i + "-filter").options.selectedIndex
      ].innerText;
      const preselectedACLName = document.getElementById("ACL-" + i + "-filter")
        .options[
        document.getElementById("ACL-" + i + "-filter").options.selectedIndex
      ].innerText;
      const view = document.getElementById(
        "View-" + i + "-icon-checkbox"
      ).checked;
      const edit = document.getElementById(
        "Edit-" + i + "-icon-checkbox"
      ).checked;
      const id = null; // to consider the duplicated item as a new record in the Backend
      var enabled;
      if (
        document.getElementById("status-" + i + "-switch-holder").classList
          .length > 1
      ) {
        enabled = false;
      } else {
        enabled = true;
      }
      const Index = parseInt(i + 1);
      RowsData.splice(Index, 0, {
        ...RowItem,
        aclId,
        scopeId,
        preselectedScopeName,
        preselectedACLName,
        edit,
        view,
        id,
        enabled,
      });
      return RowsData;
    });
  };
  // handles the duplication of the newly added rows
  const duplicateAddedItem = (RowItem, i) => {
    enableSave();
    setAddedItems((data) => {
      let RowsData = [...data]; // itterating the current data
      // creating the duplicate item properties
      const aclId = `${document.getElementById("ACL-" + i + "-filter").value}`;
      const scopeId = `${
        document.getElementById("Scope-" + i + "-filter").value
      }`;
      const preselectedScopeName = document.getElementById(
        "Scope-" + i + "-filter"
      ).options[
        document.getElementById("Scope-" + i + "-filter").options.selectedIndex
      ].innerText;
      const preselectedACLName = document.getElementById("ACL-" + i + "-filter")
        .options[
        document.getElementById("ACL-" + i + "-filter").options.selectedIndex
      ].innerText;
      const view = document.getElementById(
        "View-" + i + "-icon-checkbox"
      ).checked;
      const edit = document.getElementById(
        "Edit-" + i + "-icon-checkbox"
      ).checked;
      const id = null; // to consider the duplicated item as a new record in the Backend
      var enabled;
      if (
        document.getElementById("status-" + i + "-switch-holder").classList
          .length > 1
      ) {
        enabled = false;
      } else {
        enabled = true;
      }
      const Index = parseInt(i + 1 - PageData.length);
      RowsData.splice(Index, 0, {
        ...RowItem,
        aclId,
        scopeId,
        preselectedScopeName,
        preselectedACLName,
        edit,
        view,
        id,
        enabled,
      });
      return RowsData;
    });
  };
  const cancelOperation = () => {
    let Status = window.localStorage.getItem("HasUnsaveChanges");
    if (Status == 1) {
      setUnsavedChanges(true);
    } else {
      window.localStorage.removeItem("CreatedProfileId");
      window.localStorage.removeItem("CreatedProfileNameString");
      window.localStorage.removeItem("CreatedProfileDesc");
      window.localStorage.removeItem("MappingCreated");
      window.location.assign("/home/securityProfiles");
    }
  };
  const discardAndLeave = () => {
    window.location.assign("/home/securityProfiles");
  };
  const saveAndLeave = () => {
    validateEntries();
  };
  const validateEntries = () => {
    let AllDataLength = parseInt(PageData.length + AddedItems.length);

    for (let i = 0; i < AllDataLength; i++) {
      let ParentId = document.getElementById("Scope-" + i + "-filter").value;
      let ACLId = document.getElementById("ACL-" + i + "-filter").value;
      if (
        ParentId.length === 0 ||
        ACLId.length === 0 ||
        ParentId === "Not specified" ||
        ACLId === "Not specified"
      ) {
        setHasErrors(true);
        if (ParentId.length === 0 || ParentId === "Not specified") {
          document
            .getElementById("Scope-" + i + "-holder")
            .classList.add("cx-select-error-is-shown");
        }
        if (ACLId.length === 0 || ACLId === "Not specified") {
          document
            .getElementById("ACL-" + i + "-holder")
            .classList.add("cx-select-error-is-shown");
        }
      } else {
        setHasErrors(false);
      }
    }
    if (!HasErrors) {
      save();
    }
  };
  const save = () => {
    setIsLoading(true);
    let Data = [];
    PageData.concat(AddedItems).map((Item, i) => {
      let Record = {
        aclId: document.getElementById("ACL-" + i + "-filter").value,
        edit: document.getElementById("Edit-" + i + "-icon-checkbox").checked,
        roleId: CreatedProfileId,
        scopeId: document.getElementById("Scope-" + i + "-filter").value,
        view: document.getElementById("View-" + i + "-icon-checkbox").checked,
      };
      if (
        document.getElementById("status-" + i + "-switch-holder").classList
          .length > 1
      ) {
        Record.enabled = false;
      } else {
        Record.enabled = true;
      }
      if (window.localStorage.getItem("MappingCreated") == 1) {
        Record.id = Item.id;
      } else {
        Record.id = null;
      }
      Data.push(Record);
    });

    if (
      window.localStorage.getItem("MappingCreated") == 1 &&
      IdsToDelete.length > 0
    ) {
      requestDeleteItems();
    } else {
      requestSave(Data);
    }
  };
  const requestSave = (Data) => {
    let Req = {
      method: "PUT",
      baseURL: window._env_.API_URL + Config.ACLBaseURL + "/api/mapping/batch",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "application/json",
      },
      data: JSON.stringify({ items: Data }),
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        window.localStorage.setItem("MappingCreated", 1); // 1 means true, 0 means false
        disableSaveBtn();
        setIsLoading(false);
      })
      .catch((Err) => {
        console.log(Err.response);
        setIsLoading(false);
      });
  };
  const requestDeleteItems = () => {
    let Req = {
      method: "DELETE",
      baseURL: window._env_.API_URL + Config.ACLBaseURL + "/api/mapping/batch",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "application/json",
      },
      data: { ids: IdsToDelete },
    };
    axios(Req)
      .then(() => {
        let Data = [];
        PageData.concat(AddedItems).map((Item, i) => {
          let Record = {
            aclId: document.getElementById("ACL-" + i + "-filter").value,
            edit: document.getElementById("Edit-" + i + "-icon-checkbox")
              .checked,
            roleId: CreatedProfileId,
            scopeId: document.getElementById("Scope-" + i + "-filter").value,
            view: document.getElementById("View-" + i + "-icon-checkbox")
              .checked,
          };
          if (
            document.getElementById("status-" + i + "-switch-holder").classList
              .length > 1
          ) {
            Record.enabled = false;
          } else {
            Record.enabled = true;
          }
          if (window.localStorage.getItem("MappingCreated") == 1) {
            Record.id = Item.id;
          } else {
            Record.id = null;
          }
          Data.push(Record);
        });
        requestSave(Data);
      })
      .catch((Err) => {
        console.log(Err.response);
      });
  };
  const showDeleteAddedItem = (i) => {
    setAddedItemToDelete(i - PageData.length);
    setDeleteAddedItemIsOpen(true);
  };
  const addToList = () => {
    AddedItems.push({
      createdTime: new Date().toISOString(),
      deleted: false,
      description: "",
      enabled: true,
      preselectedACLName: "",
      preselectedScopeName: "",
      id: null,
      view: true,
      edit: true,
      name: "Not Specified",
      updatedTime: new Date().toISOString(),
    });
    enableSave();
    setDataIsLoaded(!DataIsLoaded);
  };
  const deleteAddedItem = () => {
    AddedItems.splice(AddedItemToDelete, 1);
    setDataIsLoaded(!DataIsLoaded);
    setDeleteAddedItemIsOpen(false);
  };
  const cancelDeleteAddedItem = () => {
    setDeleteAddedItemIsOpen(false);
  };
  // selects the all data default ACL as the initial value for the ACLs dropdowns on <ACLMappingRowItem/>
  const sortACLs = (List) => {
    let Default = List.filter((Item) => {
      return Item.id === "ca3215af-6711-4029-800d-d583d209b7b3";
    });
    let Others = List.filter((Item) => {
      return Item.id !== "ca3215af-6711-4029-800d-d583d209b7b3";
    });
    return Default.concat(Others);
  };
  return (
    <React.Fragment>
      {UnsavedChanges ? (
        <UnsavedChangesAlert
          close={() => closeAlert()}
          saveAndLeave={() => saveAndLeave()}
          discardAndLeave={() => discardAndLeave()}
          LangData={props.LangData}
        />
      ) : null}
      {DeleteIsOpen ? (
        <Alert
          acceptDelete={() => acceptDelete()}
          cancelDelete={() => cancelDelete()}
          IsDelete
          LangData={props.LangData}
        />
      ) : null}
      {DeleteAddedItemIsOpen ? (
        <Alert
          acceptDelete={() => deleteAddedItem()}
          cancelDelete={() => cancelDeleteAddedItem()}
          IsDelete
          LangData={props.LangData}
        />
      ) : null}
      <div className="form">
        <section className="form-header">
          <button className="return" onClick={() => cancelOperation()}>
            <i className="feather-arrow-left"></i>
          </button>
          {ProfileName.length === 0 ? (
            <h1>New Profile</h1>
          ) : (
            <h1>{ProfileName}</h1>
          )}
          <div className="action-btn-group">
            <button onClick={() => cancelOperation()} className="cancel">
              {translateText("cancel")}
            </button>
            {IsLoading ? (
              <button
                onClick={() => null} //this button is disabled and won't act when loading is set to true
                id="save-btn"
                className="save no-action"
              >
                <img alt="" className="rotator" src={Rotator} />
              </button>
            ) : (
              <button
                onClick={() => validateEntries()}
                id="save-btn"
                className="save disabled"
              >
                {translateText("save")}
              </button>
            )}
          </div>
        </section>
        <div className="form-row titles">
          <section className="xlarge left">
            <p>{translateText("scope")}</p>
          </section>
          <section className="xlarge left">
            <p>{translateText("acls")}</p>
          </section>
          <section className="large triple">
            <p>{translateText("view")}</p>
            <p>{translateText("edit")}</p>
            <p>{translateText("status")}</p>
          </section>
          <section className="large centered">
            <p>{translateText("duplicate")}</p>
          </section>
        </div>
        <React.Fragment>
          {PageData === undefined ? null : (
            <React.Fragment>
              {PageData.map((Item, i) => (
                <ACLMappingRowItem
                  Item={Item}
                  Key={Item.aclId}
                  EnableSave={() => enableSave()}
                  Index={i}
                  DeleteIcon={Delete}
                  Scopes={Scopes}
                  ACLs={sortACLs(ACLs)}
                  ViewActive={ViewActive}
                  ViewDeactive={ViewDeactive}
                  EditActive={EditActive}
                  EditDeactive={EditDeactive}
                  ShowDeleteAlert={(Index, ItemId) =>
                    showDeleteAlert(Index, ItemId)
                  }
                  DuplicateItem={(RowItem, Index) =>
                    duplicateItem(RowItem, Index)
                  }
                  HandleCheckboxChange={(SelectedName, Index) =>
                    handleCheckboxChange(SelectedName, Index)
                  }
                  HandleSwitchChange={() => handleSwitchChange()}
                  HandleEdit={(Index) => handleEdit(Index)}
                  LangData={props.LangData}
                />
              ))}
            </React.Fragment>
          )}
        </React.Fragment>
        <React.Fragment>
          {AddedItems.map((NewItem, i) => (
            <ACLMappingAddedRowItem
              key={i}
              NewItem={NewItem}
              Index={i}
              PageData={PageData}
              EnableSave={() => enableSave()}
              Scopes={Scopes}
              ACLs={ACLs}
              DeleteIcon={Delete}
              ViewActive={ViewActive}
              ViewDeactive={ViewDeactive}
              EditActive={EditActive}
              EditDeactive={EditDeactive}
              HandleCheckboxChange={(SelectedName, Index) =>
                handleCheckboxChange(SelectedName, Index)
              }
              HandleSwitchChange={() => handleSwitchChange()}
              DuplicateAddedItem={(NewItem, Index) =>
                duplicateAddedItem(NewItem, Index)
              }
              ShowDeleteAlert={(Index) => showDeleteAddedItem(Index)}
              LangData={props.LangData}
              SectionErrorText={translateText("specify_parent_error")}
              ACLErrorText={translateText("specify_acl_name_error")}
            />
          ))}
        </React.Fragment>
        <button onClick={() => addToList()} className="add-to-list">
          <img alt="" src={BluePlus} />
          {translateText("add")}
        </button>
      </div>
    </React.Fragment>
  );
};

export default Mapping;
